<mbs-card
  class="mbs-plan-detail h-auto"
  [customClasses]="'bg-light border-radius-xl-important h-auto'"
  [hasPadding]="false"
  [id]="idPrefix() + '-step-card'"
  [innerBordered]="false"
  [size]="MbsSize.xs">
  @if (error()) {
    <mbs-card-group class="w-100 p-3">
      <mbs-alert
        class="mb-0"
        [icon]="true"
        [type]="popupType.danger">
        {{ error() }}
      </mbs-alert>
    </mbs-card-group>
  }

  <mbs-card-group class="w-100 p-3">
    <div class="form-row">
      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(azureAccounts())"
          [id]="idPrefix() + '-azure-account-select'"
          [items]="azureAccounts()"
          [label]="'mbs-ui:cloud-restore.cloudInstanceStep.azureAccount' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="azureAccount()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('azureAccount', $event)"></mbs-select>
      </div>

      @if (!isTemporary()) {
        <div class="col-6">
          <mbs-input
            mbsComputerNameValidation
            [id]="idPrefix() + '-computer-name-input'"
            [label]="'mbs-ui:cloud-restore.cloudInstanceStep.computerName' | i18next: { format: 'title' }"
            [ngModel]="computerName()"
            [required]="true"
            [showRequiredMark]="false"
            (ngModelChange)="valueChangeHandler('computerName', $event)"></mbs-input>
        </div>
      }
    </div>
  </mbs-card-group>

  <mbs-card-group class="w-100 p-3">
    <div class="form-row">
      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(locations())"
          [id]="idPrefix() + '-location-select'"
          [items]="locations()"
          [label]="'mbs-ui:cloud-restore.cloudInstanceStep.location' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="location()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('location', $event)"></mbs-select>
      </div>

      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(resourceGroups())"
          [id]="idPrefix() + '-resource-group-select'"
          [items]="resourceGroups()"
          [label]="'mbs-ui:cloud-restore.cloudInstanceStep.resourceGroup' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="resourceGroup()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('resourceGroup', $event)"></mbs-select>
      </div>
    </div>
  </mbs-card-group>

  <mbs-card-group class="w-100 p-3">
    <div class="form-row">
      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(vmSizes())"
          [id]="idPrefix() + '-vm-size-select'"
          [items]="vmSizes()"
          [label]="'mbs-ui:cloud-restore.cloudInstanceStep.vmSize' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="vmSize()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('vmSize', $event)">
          <ng-template
            #mbsSelectLabelTmp
            let-item="item">
            <mbs-text-ellipsis [tooltip]="item.name">{{ item.name }}</mbs-text-ellipsis>
          </ng-template>
          <ng-template
            #mbsSelectOptionTmp
            let-item="item">
            <mbs-text-ellipsis [tooltip]="item.name">{{ item.name }}</mbs-text-ellipsis>
          </ng-template>
        </mbs-select>
      </div>

      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(networks())"
          [id]="idPrefix() + '-network-select'"
          [items]="networks()"
          [label]="'mbs-ui:cloud-restore.cloudInstanceStep.network' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="network()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('network', $event)">
          <ng-template
            #mbsSelectLabelTmp
            let-item="item">
            <mbs-text-ellipsis [tooltip]="item.name">{{ item.name }}</mbs-text-ellipsis>
          </ng-template>
          <ng-template
            #mbsSelectOptionTmp
            let-item="item">
            <mbs-text-ellipsis [tooltip]="item.name">{{ item.name }}</mbs-text-ellipsis>
          </ng-template>
        </mbs-select>
      </div>
    </div>
  </mbs-card-group>

  <mbs-card-group class="w-100 p-3">
    <div class="form-row">
      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(subnets())"
          [id]="idPrefix() + '-subnet-select'"
          [items]="subnets()"
          [label]="'mbs-ui:cloud-restore.cloudInstanceStep.subnet' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="subnet()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('subnet', $event)">
          <ng-template
            #mbsSelectLabelTmp
            let-item="item">
            <mbs-text-ellipsis [tooltip]="item.name">{{ item.name }}</mbs-text-ellipsis>
          </ng-template>
          <ng-template
            #mbsSelectOptionTmp
            let-item="item">
            <mbs-text-ellipsis [tooltip]="item.name">{{ item.name }}</mbs-text-ellipsis>
          </ng-template>
        </mbs-select>
      </div>

      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(storages())"
          [id]="idPrefix() + '-storage-select'"
          [items]="storages()"
          [label]="'mbs-ui:cloud-restore.cloudInstanceStep.storage' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="storage()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('storage', $event)">
          <ng-template
            #mbsSelectLabelTmp
            let-item="item">
            <mbs-text-ellipsis [tooltip]="item.name">{{ item.name }}</mbs-text-ellipsis>
          </ng-template>
          <ng-template
            #mbsSelectOptionTmp
            let-item="item">
            <mbs-text-ellipsis [tooltip]="item.name">{{ item.name }}</mbs-text-ellipsis>
          </ng-template>
        </mbs-select>
      </div>
    </div>
  </mbs-card-group>

  <mbs-card-group class="w-100 p-3">
    <div class="form-row">
      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(containers())"
          [id]="idPrefix() + '-container-select'"
          [items]="containers()"
          [label]="'mbs-ui:cloud-restore.cloudInstanceStep.container' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="container()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('container', $event)"></mbs-select>
      </div>

      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(bootDiagnosticStorages())"
          [id]="idPrefix() + '-boot-diagnostic-storage-select'"
          [items]="bootDiagnosticStorages()"
          [label]="'mbs-ui:cloud-restore.cloudInstanceStep.bootDiagnosticStorage' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="bootDiagnosticStorage()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('bootDiagnosticStorage', $event)"></mbs-select>
      </div>
    </div>
  </mbs-card-group>
</mbs-card>
